//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 通用网络错误显示组件
require('../../assets/scss/netError.scss');

export default {
    data() {
        return {
            title: '哎呀，出错啦~',
            content: '网络或服务可能存在问题，刷新试试吧',
            btnContent: '刷新试试'
        };
    },
    props: {
        errorShow: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        retry() {
            window.location.reload();
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/common/netError.vue